

export interface QueryDispatcher{
  dispatch(q_name,args):Promise<{[key: string]: any} >;
}

export interface QueryDispatcherAbort{
  dispatch(q_name,args);
}

export class Result {
  promise;
  controller:AbortController;

  constructor(promise, controller: AbortController) {
    this.promise = promise;
    this.controller = controller;
  }

}